export default __webpack_public_path__ + "static/media/dealer-line.1b2cfff6.svg";